
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ItemsSummaryMobile extends Vue {
  @Prop({ required: true }) items!: unknown[];

  @Prop({ required: true }) detailsInPlainText!: () => void;

  @Prop({ required: true }) itemLabel!: string;

  @Prop({ required: false, default: false }) isEditItem!: boolean;

  @Prop({ required: false, default: false }) isDuplicateItem!: boolean;
}
